export const GRANULAR_FEEDBACK_PROPS = {
  feedbackReasonOptions: {
    type: Array as () => string[],
    required: true,
  },
  granularFeedback: {
    type: String,
    required: false,
    default: undefined,
  },
} as const
